import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useSelector } from 'react-redux';

import configurations from '@/config';
import { getAccessToken } from '@/utils/api';

export interface UpdateNotesBody {
  editedSummary: string;
}

export const useUpdateNotes = () => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useMutation({
    mutationFn: async ({
      clinicalNoteId,
      updateNotesBody,
    }: {
      clinicalNoteId: string;
      updateNotesBody: UpdateNotesBody;
    }) => {
      const { data } = await axios.patch(
        `${configurations.API_URL}/videa-notes/${clinicalNoteId}/summary`,
        updateNotesBody,
        {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
            'Content-Type': 'application/json',
            practice: currentPracticeId,
            org: currentOrganizationId,
          },
        },
      );
      return data;
    },
  });
};
